import { render, staticRenderFns } from "./Archive2025Component.vue?vue&type=template&id=343fb32d&scoped=true"
import script from "./Archive2025Component.vue?vue&type=script&lang=js"
export * from "./Archive2025Component.vue?vue&type=script&lang=js"
import style0 from "./Archive2025Component.vue?vue&type=style&index=0&id=343fb32d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343fb32d",
  null
  
)

export default component.exports